module.exports = __webpack_public_path__ + "static/img/address.85970e5c.svg";